<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

<div class="reset-init">
    <h2>{{ 'reset.request.title' | translate }}</h2>

    <winde-alert-error></winde-alert-error>

    <div *ngIf="success === 'OK'" class="alert alert-success">{{ 'reset.request.messages.success' | translate }}</div>

    <ng-container *ngIf="!success">
        <div class="control">
            <div class="control-label">{{ 'reset.request.form.email' | translate }}</div>
            <sui-string-component [config]="user.login" class="sui-e2e-email"></sui-string-component>
        </div>
        <button (click)="requestReset()" windeGreen>
            {{ 'entity.action.submit' | translate }}
        </button>
    </ng-container>
    <br/>
    <a class="d-inline-block mt-3" routerLink="/"> Back to homepage </a>
</div>
